<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    check?: boolean
    type?:
      | 'success'
      | 'danger'
      | 'attention'
      | 'info'
      | 'default'
      | 'processing'
    title?: string
    icon?: string
  }>(),
  {
    check: undefined,
  },
)
const statuses = [
  {
    status: 'attention',
    words: ['attention', 'warning', 'pause', 'draft', 'scheduled-daily'],
  },
  {
    status: 'danger',
    words: ['danger', 'error', 'stopped', 'failed'],
  },
  {
    status: 'info',
    words: ['info', 'new', 'waiting', 'pending'],
  },
  {
    status: 'processing',
    words: ['processing', 'running', 'started'],
  },
  {
    status: 'success',
    words: ['success', 'done', 'published', 'processed', 'finished', 'process'],
  },
]
const autoIcon = computed(() =>
  props.check !== undefined
    ? props.check
      ? 'i-heroicons-solid:check'
      : 'i-heroicons-solid:x'
    : props.icon,
)
const autoType = computed(() =>
  props.check !== undefined
    ? props.check
      ? 'success'
      : 'default'
    : statuses.find(({ words }) =>
        words.some((word) => props.title?.includes(word)),
      )?.status,
)
</script>

<template>
  <span
    class="px-2 py-0.5 inline-flex items-center justify-between gap-x-1 text-xs leading-5 font-medium rounded-full"
    :class="[
      {
        success: 'bg-green-100 text-green-800',
        attention: 'bg-orange-100 text-orange-800',
        danger: 'bg-red-100 text-red-800',
        info: 'bg-primary-100 text-primary-800',
        default: 'bg-gray-100 text-gray-700',
        processing: 'bg-blue-100 text-blue-800',
      }[type || autoType || 'default'],
      { 'py-1': !($slots.default || title) },
    ]"
  >
    <div
      v-if="autoIcon"
      :class="[
        autoIcon,
        {
          success: 'text-green-500',
          attention: 'text-orange-500',
          danger: 'text-red-500',
          info: 'text-primary-500',
          default: 'text-gray-500',
          processing: 'text-blue-500',
        }[type || autoType || 'default'],
        { '-ml-0.5': $slots.default },
      ]"
    />
    <div v-if="$slots.default || title">
      <slot>
        {{ title }}
      </slot>
    </div>
  </span>
</template>
